import $dom from 'cash-dom';
import Glide from '@glidejs/glide';

const pdpCarousel = () => {
  const $pdpCarouselElem = $dom('[data-pdp-carousel]');

  if ($pdpCarouselElem.length === 0) {
    return false;
  }

  const carousel = new Glide($pdpCarouselElem[0], {
    type: 'slider',
    rewind: false,
    classes: {
      carousel: 'pdp-carousel',
      cloneSlide: 'pdp-carousel-slide-clone',
      activeNav: 'is-active',
      activeSlide: 'is-active',
      disabledArrow: 'is-disabled'
    }
  });

  carousel.mount({
    Video: function(Glide, Components, Events) {
      return {
        mount() {
          const { slides } = Components.Html;

          const hasVideo = slides.some(slide => slide.dataset.videoId);

          if (!hasVideo) {
            return false;
          }

          let activeSlide = null;

          Events.on('run.before', function() {
            if (activeSlide && activeSlide.YTplayer) {
              activeSlide.YTplayer.pauseVideo();
            }
          });

          Events.on('run.after', function() {
            activeSlide = slides[Glide.index];

            if (activeSlide.YTplayer) {
              activeSlide.YTplayer.playVideo();
            }
          });

          import(
            /* webpackChunkName: "youtube-player" */ 'youtube-player'
          ).then(({ default: YouTubePlayer }) => {
            slides.forEach(slide => {
              const $slide = $dom(slide);

              $slide.on('click', () => {
                if ($slide.data('videoId') && !slide.YTplayer) {
                  const videoElem = document.createElement('div');

                  $slide.append(videoElem);

                  slide.YTplayer = YouTubePlayer(videoElem, {
                    videoId: $slide.data('videoId'),
                    height: $slide.height(),
                    width: $slide.width(),
                    playerVars: {
                      controls: 1,
                      autoplay: 1,
                      disablekb: 1,
                      enablejsapi: 1,
                      iv_load_policy: 3,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  });
                }
              });
            });
          });
        }
      };
    }
  });
};

export default pdpCarousel;
